import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import { IBaseStore } from '@/store/types'
import {
    ELetterStatus,
    ILetter,
    ILettersBatchDashboardStatistics,
    ILettersFiltersDTO, IMailStatements,
    IStatement
} from '@zunta/configurations'
import Api from '@/api'

export interface ILettersState {

}

export interface ILettersStore extends IBaseStore {
    state: ILettersState
}

@Module({
    name: 'letter',
    namespaced: true
})
export class LettersModule extends VuexModule {
    lettersStatistics: ILettersBatchDashboardStatistics | null = null;
    isShowSuccessModal: boolean = false

    letterList: ILetter[] = [];
    letterTotal: number = 0;
    selectedLetter: ILetter | null = null;

    mailStatements: IMailStatements | null = null;

    @Mutation
    SET_LETTERS_STATISTICS (statistics: ILettersBatchDashboardStatistics | null) {
        this.lettersStatistics = statistics
    }

    @Mutation
    UPDATE_LETTER_LIST (letters: ILetter[]) {
        this.letterList = letters
    }

    @Mutation
    UPDATE_LETTERS_TOTAL (total: number) {
        this.letterTotal = total
    }

    @Mutation
    SET_SELECTED_LETTER (letter: ILetter | null) {
        this.selectedLetter = letter
    }

    @Mutation
    UPDATE_MAIL_STATEMENTS (statements: IMailStatements | null) {
        this.mailStatements = statements
    }

    @Mutation
    UPDATE_SELECTED_LETTER (input: { statementId: number | string, data: Partial<IStatement| ILetter> }) {
        const letter = this.letterList.find((letter: ILetter) => letter.id === parseInt(input.statementId.toString(), 10))
        Object.keys(input.data).forEach((key: string) => {
            (letter as any)[key] = (input.data as any)[key]
        })
    }

    @Action
    async changeLetterStatus (input: { letterId: number | string, status: ELetterStatus }) {
        const response = await Api.statement.changeLetterStatus(input.letterId, input.status)
        if (response === 'OK') {
            try {
                this.UPDATE_SELECTED_LETTER({
                    statementId: input.letterId,
                    data: { status: input.status }
                })
            } catch (e) {
                console.log(e)
            }
        }
        return response
    }

    @Action
    async fetchLettersBatchStatistics (batchId: string | number) {
        const statistics = await Api.letter.fetchLettersBatchStatistics(batchId)
        this.SET_LETTERS_STATISTICS(statistics)
    }

    @Action
    async fetchBatchLettersByFilters (input: { batchId: number | string, filters: ILettersFiltersDTO }) {
        const response = await Api.letter.fetchBatchLetters(input.batchId, input.filters)
        if (response.letters) {
            this.UPDATE_LETTER_LIST(response.letters)
            this.UPDATE_LETTERS_TOTAL(response.total)
        }
    }

    // @Action
    // async sendLettersBatchMails (batchId: number | string) {
    //     return Api.statement.sendLettersBatchMails(batchId)
    // }
    //
    // @Action
    // async fetchMailStatements (batchId: number | string) {
    //     const statements = await Api.statement.getMailStatements(batchId)
    //     this.UPDATE_MAIL_STATEMENTS(statements)
    // }

    @Action
    async fetchLetterById (letterID: number | string) {
        const letter = await Api.letter.getLetterById(letterID)
        this.SET_SELECTED_LETTER(letter)
    }

    // @Action
    // clearMailStatements () {
    //     this.UPDATE_MAIL_STATEMENTS(null)
    // }

    @Action
    resetStatistics () {
        this.SET_LETTERS_STATISTICS(null)
    }

    @Mutation
    SET_SUCCESS_MODAL_OPEN (toggle: boolean) {
        this.isShowSuccessModal = toggle
    }

    @Action
    showSuccessModal () {
      this.SET_SUCCESS_MODAL_OPEN(true)
    }

    @Action
    closeSuccessModal () {
      this.SET_SUCCESS_MODAL_OPEN(false)
    }
}
